import * as v from "valibot";

import { rpcContract } from "../rpc";

export const getFanJoinedCommunitiesRpcContract = rpcContract({
  name: "get-fan-joined-communities",
  paramsSchema: v.object({
    limit: v.optional(v.pipe(v.number(), v.minValue(1), v.maxValue(50)), 10),
    offset: v.optional(v.pipe(v.number(), v.minValue(0)), 0),
  }),
  resultSchema: v.object({
    communities: v.array(
      v.object({
        id: v.string(),
        title: v.string(),
        description: v.nullable(v.string()),
        thumbnail_url: v.nullable(v.string()),
        cta_text: v.nullable(v.string()),
        content_tier: v.string(),
        fee_cents: v.nullable(v.number()),
        influencer_id: v.string(),
        influencer_handle: v.nullable(v.string()),
        influencer_display_name: v.nullable(v.string()),
        influencer_avatar: v.nullable(v.string()),
        primary_color: v.nullable(v.string()),
        secondary_color: v.nullable(v.string()),
        member_count: v.nullable(v.number()),
        joined_at: v.string(),
      }),
    ),
    totalCount: v.number(),
    hasMore: v.boolean(),
  }),
});

export type GetFanJoinedCommunitiesParams = v.InferOutput<(typeof getFanJoinedCommunitiesRpcContract)["paramsSchema"]>;
export type GetFanJoinedCommunitiesResult = v.InferOutput<(typeof getFanJoinedCommunitiesRpcContract)["resultSchema"]>;
export type FanJoinedCommunity = v.InferOutput<
  (typeof getFanJoinedCommunitiesRpcContract)["resultSchema"]
>["communities"][0];
